import { OmniElement, html, css, map } from 'omni-ui';
import { capitalizeWord } from '../../helpers/utils.js';

// These role for comms colors are shared across studio modules
export const rfcColors = {
  activating: '#E2A951',
  impacting: '#E25D69',
  reinforcing: '#3E7BAD',
  building: '#35B67D',
};

export class CampaignRFCLegend extends OmniElement {
  static get styles() {
    return css`
      omni-tile {
        --drag-able-z: 6;
        --drag-left: 80%;
        --drag-top: 25%;
        width: 16rem;
      }
      omni-tile::part(body-slot) {
        margin: 1.14rem 0 2.14rem 0;
      }
      .rfc-container {
        display: flex;
        flex-flow: column nowrap;
        gap: 0.57rem;
      }
      .rfc{
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        gap: 0.86rem;
        padding: 0.57rem 1.43rem;
      }
      .rfc-color {
        width: 1.14286rem;
        height: 1.14286rem;
        border-radius: 50%;
      }
      .rfc-role {
        line-height: 1.57143rem;
        letter-spacing: 0.00307rem;
      }
      .
    `;
  }

  constructor() {
    super();
    this.rfc = Object.entries(rfcColors).map(([role, color]) => ({
      role: capitalizeWord(role),
      color,
    }));
  }

  render() {
    return html`
      <omni-style>
        <omni-tile drag-able>
          <omni-toolbar slot="header">
            <h3 slot="start" class="title is-4 has-text-weight-normal">
              Legend
            </h3>
            <button
              slot="end"
              class="button is-text is-shadowless"
              @click=${() => this.dispatchNewEvent('close-rfc-legend')}
            >
              <omni-icon
                class="is-size-1"
                icon-id="omni:interactive:minus"
              ></omni-icon>
            </button>
          </omni-toolbar>
          ${map(
            this.rfc,
            rfc => html`
              <div class="rfc-container">
                <div class="rfc">
                  <div
                    class="rfc-color"
                    style="background-color:${rfc.color}"
                  ></div>
                  <div class="rfc-role">${rfc.role}</div>
                </div>
              </div>
            `,
          )}
        </omni-tile>
      </omni-style>
    `;
  }
}

OmniElement.register('campaign-audience-rfc-legend', CampaignRFCLegend);
